import * as React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {ProductsEnum} from "@falcon/services";
import {CollapseTextWidget} from "@falcon/plugin-falcon-journey";

interface IAutoRenewalQuestionProps {
    onSave: (automaticRenewal: boolean) => void;
    product: ProductsEnum;
}
interface IAutoRenewalQuestionState {
    isOpen: boolean;
    automaticRenewal: boolean;
    showSuccessModal: boolean;
}

export class AutoRenewalQuestionModal extends React.Component<IAutoRenewalQuestionProps, IAutoRenewalQuestionState> {

    constructor(props: IAutoRenewalQuestionProps) {
        super(props);

        this.state = {
            isOpen: true,
            automaticRenewal: true,
            showSuccessModal: false,
        };
    }

    public render() {
        return (
            <>
                {<Modal className="my-2 manual-renewal-modal" isOpen={this.state.isOpen} toggle={this.hideModal}>
                    <ModalHeader close={<button className="btn-close" onClick={this.hideModal}/>}/>
                    <ModalBody className={`pt-0 `}>

                        <h1 className="a-bold fs-20">Your policy is set to renew</h1>
                        <p className="font-family-base font-weight-semi-bold margin-top-32">
                            Next year - save time and stay covered
                        </p>
                        {this.props.product === ProductsEnum.WOLF_MOTOR && this.getMotorAutoRenewalWording()}
                        {this.props.product === ProductsEnum.HOME && this.getHomeAutoRenewalWording()}
                        <div className="opt-in-renewal-checkbox__input">
                            <p className="font-family-base font-weight-light text-blue-2 fs-16 mb-0">If you'd prefer
                                not to take advantage of this service.</p>
                            <div className="widget">
                                <CollapseTextWidget summary="Opt out here" p={
                                    <div>
                                        {this.props.product === ProductsEnum.WOLF_MOTOR && this.getMotorAutoRenewalOptOutWording()}
                                        {this.props.product === ProductsEnum.HOME && this.getHomeAutoRenewalOptOutWording()}
                                        <p className="font-family-base font-weight-semi-bold text-blue-2 fs-16 mb-0">Untick
                                            to opt out of automatic renewal</p>
                                        <div className="falcon-checkbox padding-top-0">
                                            <div className="d-flex">
                                                <div className="form-check mr-3">
                                                    <input className="custom-control-input"
                                                           type="checkbox"
                                                           name="automaticRenewalEnabled"
                                                           id="automaticRenewalEnabled"
                                                           checked={this.isChecked()}
                                                           onChange={this.onChangeAutomaticRenewal}
                                                    />
                                                    <label className="custom-control-label"
                                                           htmlFor="automaticRenewalEnabled">
                                                        <div className="checkbox-big"/>
                                                        <div className="checkbox-label">
                                                            Automatic renewal
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }/>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-flex flex-column w-100">
                            <button type="button"
                                    className="btn btn-primary btn-blue-dashboard m-auto"
                                    onClick={this.updateAutomaticRenewal}
                                    id="updateAutomaticRenewal">
                                Save changes
                            </button>
                            <button type="button"
                                    className="btn btn-white-dashboard"
                                    onClick={this.hideModal}
                                    id="cancelChanges">
                                Cancel changes
                            </button>
                        </div>

                    </ModalFooter>
                </Modal>
                }
            </>
        );
    }

    private getHomeAutoRenewalOptOutWording() {
        return <>
            <p className="font-family-base font-weight-light text-blue-2 fs-16">When automatically renewing, you save
                time and effort and guarantee there’s no gap in your cover.</p>
            <p className="font-family-base font-weight-light text-blue-2 fs-16">If you opt out, your policy will end on
                its renewal date and you’ll need alternative cover in place if you don’t want to be left uninsured.</p>
        </>;
    }

    private getMotorAutoRenewalOptOutWording() {
        return <>
            <p className="font-family-base font-weight-light text-blue-2 fs-16">When automatically renewing, you ensure
                there's no interruption to your cover and avoid driving uninsured.</p>
            <p className="font-family-base font-weight-light text-blue-2 fs-16">By opting out, your policy will end on
                it's renewal date and you will need to have alternative cover in place or declare the vehicle off
                road.</p>
        </>;
    }

    private getMotorAutoRenewalWording() {
        return <>
            <p className="font-family-base font-weight-light text-blue-2 fs-16">To make
                things easier for you, we'll set your policy to automatically renew next year. This doesn't
                affect your price and gives you peace of mind that you won't be left driving uninsured.
                Remember, it's a legal requirement to insure your car if it's on a road.
            </p>
            <p className="font-family-base font-weight-light text-blue-2 fs-16">We'll tell
                you your new price and cover details 4 weeks before your renewal date, giving you plenty of
                time to let us know if you need to make changes and you can opt out of renewing
                automatically for free at any time.
            </p>
        </>;
    }

    private getHomeAutoRenewalWording() {
        return <>
            <p className="font-family-base font-weight-light text-blue-2 fs-16">To make things easier
                for you, we'll set your policy to automatically renew next year. This doesn’t affect your price and
                means your home stays protected without any gaps, so you have peace of mind.
            </p>
            <p className="font-family-base font-weight-light text-blue-2 fs-16">We’ll let you know your new price
                and cover details 4 weeks before your renewal date, so you have plenty of time to make changes if needed
                - and you can opt out of renewing automatically for free at any time.
            </p>
        </>;
    }

    private isChecked(): boolean {
        return this.state.automaticRenewal;
    }

    private readonly updateAutomaticRenewal = (): void => {
        this.props.onSave(this.state.automaticRenewal);
        this.hideModal();
    }

    private readonly hideModal = (): void => {
        this.setState({
            isOpen: false
        });
    }

    private readonly onChangeAutomaticRenewal = (event: any) => {
        const value: boolean = event.target.checked;
        this.setState({
            automaticRenewal: value
        })
    }
}
